export default "__VITE_ASSET__DsK47HcK__"